import React from 'react';

export default function GroupByPositionToggle({ value, onChange }) {
	return (
		<button
			type="button"
			role="switch"
			aria-checked={value}
			className={`group-by-position-toggle${value ? ' is-on' : ''}`}
			onClick={() => onChange?.(!value)}>
			<span className="group-by-position-toggle-label">Group by position</span>
			<span className="group-by-position-toggle-track" aria-hidden="true">
				<span className="group-by-position-toggle-thumb" />
			</span>
		</button>
	);
}
